




























import { Component, Prop, Mixins } from 'vue-property-decorator'
import { ScreenText } from '@/lang/ScreenText'
import ErrorModal from '@/popupcomponents/ErrorModal.vue'
import cart from '@/store/modules/checkout/cart/module'
import { CartItem } from '@/Model/checkout/cart/types'
import Spinner from '@/commoncomponents/spinner/Spinner.vue'
import APP_CONST from '@/constants/AppConst'
import AccountSettings from '@/mixins/accountSettings.mixin'

@Component({
  components: {
    Spinner,
    ErrorModal
  }
})
export default class SessionUnavailableAlert extends Mixins(AccountSettings) {
  public isVisible = false
  @Prop({ type: Array, default: () => [] }) private itemsToRemove!: CartItem[]

  public readonly screenText = new ScreenText()
  APP_CONST = APP_CONST

  get formattedMessage(): string {
    if (this.itemsToRemove.length > 0) {
      return this.screenText
        .getScreenText('SESSION_UNAVAILABLE_MESSAGE')
        .replace('{session_title}', this.itemsToRemove[0].session.sessionName)
    } else {
      return this.screenText.getScreenText('SESSION_UNAVAILABLE_MESSAGE_GENERIC')
    }
  }

  get removalInProgress(): boolean {
    return cart.isDeleting || cart.isUpdatingCart
  }

  public async removeItems() {
    await Promise.all(this.itemsToRemove.map((e) => cart.removeSpecificCartItem(e)))

    if (this.itemsToRemove.length == 0) {
      // Emit close event
      this.$emit('closepopup')
      this.isVisible = false
    }
  }

  public mounted() {
    this.isVisible = true
  }
}
